import BatteryCharging20Icon from '@mui/icons-material/BatteryCharging20';
import BatteryCharging50Icon from '@mui/icons-material/BatteryCharging50';
import BatteryChargingFullIcon from '@mui/icons-material/BatteryChargingFull';
import { DashboardEvent } from '../types/DashboardEvent';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';


export const batteryEvents: DashboardEvent[ ] = [

    {
        displayOrder: 1,
        displayedHeader: 'Critical (Priority Battery Change)',
        displayedText: ' < 4.0 V',
        event: 'Critical',
        icon: <BatteryCharging20Icon sx={{color:'red'}} />
    },

    {
        displayOrder: 2,
        displayedHeader: 'Low (Monitor)',
        displayedText: '4.0 - 4.2 V',
        event: 'Low',
        icon: <BatteryCharging50Icon sx={{color:'orange'}} />
    },

    {
        displayOrder: 3,
        displayedHeader: 'Normal (Healthy)',
        displayedText: '4.2 - 4.4 V',
        event: 'Normal',
        icon: <BatteryChargingFullIcon sx={{color:'green'}} />
    },

    {
        displayOrder: 4,
        displayedHeader: 'High (Healthy)',
        displayedText: '4.4 - 4.8 V',
        event: 'High',
        icon: <BatteryChargingFullIcon sx={{color:'green'}} />
    },

    {
        displayOrder: 5,
        displayedHeader: 'Unknown',
        displayedText: '\u00A0',
        event: 'Unknown',
        icon: <ContactSupportIcon sx={{color:'brown'}} />
    }

];